(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-seo-text"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.collection-seo__details').forEach((details) => {
    if (window.matchMedia('(max-width: 699px)').matches) {
      details.removeAttribute('open');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
